export default __webpack_public_path__ + "static/media/pc.5bd6517b.png";